export default {
	INVALID_SITUATION: 'La situación del usuario es inválida',
	INVALID_STATUS: 'El estado del usuario es inválido',
	INACTIVE_USER: 'El usuario está inactivo',
	NOT_FOUND: 'El usuario es inválido o no existe',
	WRONG_PASSWORD: 'La contraseña es incorrecta',
	getHumanErrorMessage (error, group) {
		console.log(error);
		let errorResponse = error.response;
		if (error == 'Forbidden') return 'El usuario no tiene permisos.';
		//if (error.response.status == 500 && error.response.data && error.response.data.message)  return error.response.data.message;
		if (error.response && error.response.data && (error.response.data.message || error.response.data.Message)) error = error.response.data.message || error.response.data.Message;
		else return 'Ocurrio un error';
		if (error == 'Validation errors') return 'Verifique los campos.';
		if (error.includes('Forbidden')) return 'El usuario no tiene permisos.';
		if (apiErrorMessages[group]) {
			if (error.includes('duplicate key value violates unique constraint "student_school_academicyear_unique"')) return 'El alumno ya se encuentra registrado en el ciclo seleccionado';
			if (error.includes('duplicate key value violates unique constraint "student_school_academicyear"')) return 'El alumno ya se encuentra registrado en el ciclo seleccionado';
			if (apiErrorMessages[group][error]) {
				return apiErrorMessages[group][error];
			} else console.warn(`messageCode (${error}) not found in ${group} group [getHumanErrorMessage()]`);
		} else console.warn(`group ${group} not found [getHumanErrorMessage()]`);
		return 'Ocurrio un error: ' + error;
	}
};



// WEBPACK FOOTER //
// ./src/helpers/apiErrorMessages.js